import Vue from 'vue';
import store from './store';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/theme/element-theme.less';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import './assets/font/iconfont.css';
import './assets/less/base.less';
import './assets/less/ui_reset.less';
import VueClipboard from 'vue-clipboard2';
import VueQriously from 'vue-qriously';
import router from './router';
import i18n from './i18n/i18n';
import mixin from './assets/js/mixin';
import './assets/js/rem'
import BaiduMap from 'vue-baidu-map'

Vue.prototype.$shareUrl = window.location.protocol + "//" + window.location.host;

Vue.use(BaiduMap, {
  // 百度地图开发者密钥
  ak: '4XdzxY4NBWokb8mzSzdZvECLW73QmpS8'
})
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Vue.config.productionTip = false;
//引入axios
require('./axios/request');

//引入elementUI
Vue.use(ElementUI);

//引入复制粘贴板插件
Vue.use(VueClipboard);

//引入二维码插件
Vue.use(VueQriously);

Vue.prototype.print = (obj, type) => {
	type = type || "log";
	const log = JSON.parse(JSON.stringify(obj));
	console[type](log)
}
//加入混入对象
Vue.mixin(mixin);

// 替换USDT为USD
Vue.filter('replaceUSDT', function(value) {
  if (!value) return '';
  return value.replace(/USDT/g, 'USD');
});

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');
